var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrickWall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1280.000000pt",
    height: "810.000000pt",
    viewBox: "0 0 1280.000000 810.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,810.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7655 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330 7655 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4660 7655 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6990 7655 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9320 7655 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330 6645 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3660 6645 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5990 6645 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8320 6645 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10650 6645 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5635 l0 -445 1065 0 c586 0 1068 0 1073 0 4 0 8 200 10 445 l2 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330 5630 l0 -450 1075 0 1075 0 0 450 0 450 -1075 0 -1075 0 0 -450z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4660 5633 l0 -448 1072 2 1073 3 3 445 2 445 -1075 0 -1075 0 0 -447z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6992 5635 l3 -445 1070 0 1070 0 3 445 2 445 -1075 0 -1075 0 2 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9320 5633 l0 -448 1072 2 1073 3 3 445 2 445 -1075 0 -1075 0 0 -447z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3330 4620 l0 -450 1075 0 1075 0 -2 448 -3 447 -1072 3 -1073 2 0 -450z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000 4615 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5660 4615 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7990 4615 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10320 4615 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 3923 c-4 -3 -7 -204 -7 -445 l0 -438 1078 0 1077 0 -3 445 -2 445 -1069 0 c-587 0 -1071 -3 -1074 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2422 3483 l3 -448 1073 -3 1072 -2 0 450 0 450 -1075 0 -1075 0 2 -447z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4757 3923 c-4 -3 -7 -204 -7 -445 l0 -438 1078 0 1077 0 -2 442 -3 443 -1068 3 c-588 1 -1072 -1 -1075 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7088 3923 c-1 -5 -2 -205 -3 -445 l0 -438 1073 0 1072 0 0 445 0 445 -1070 0 c-588 0 -1071 -3 -1072 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9417 3923 c-4 -3 -7 -204 -7 -445 l0 -438 1078 0 1077 0 -2 442 -3 443 -1068 3 c-588 1 -1072 -1 -1075 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094 2905 c-2 -5 -3 -206 -2 -445 l3 -435 1073 -3 1072 -2 0 447 0 448 -1071 0 c-705 0 -1073 -3 -1075 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3420 2470 l0 -450 1075 0 1075 0 0 450 0 450 -1075 0 -1075 0 0 -450z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5754 2905 c-2 -5 -3 -206 -2 -445 l3 -435 1073 -3 1072 -2 0 447 0 448 -1071 0 c-705 0 -1073 -3 -1075 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8084 2905 c-2 -5 -3 -206 -2 -445 l3 -435 1073 -3 1072 -2 0 447 0 448 -1071 0 c-705 0 -1073 -3 -1075 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10414 2905 c-2 -5 -3 -206 -2 -445 l3 -435 1073 -3 1072 -2 0 447 0 448 -1071 0 c-705 0 -1073 -3 -1075 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2090 1455 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4420 1455 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6750 1455 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9080 1455 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 445 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3420 445 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5750 445 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8080 445 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10410 445 l0 -445 1075 0 1075 0 0 445 0 445 -1075 0 -1075 0 0 -445z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrickWall);
export default __webpack_public_path__ + "static/media/brick-wall.4b6a7db9.svg";
export { ForwardRef as ReactComponent };